(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products-tab"] && !Shopify.designMode) return;
  try {
    
  /* featured-products-tabs: subclass of the theme's TabsComponent
     (theme.js:2180). Adds roving tabindex (base ships it commented out),
     Home/End keys, focus-only arrow traversal (manual activation), and the
     house 300ms ease-in-out easing on the panel transition (Figma 7127:60479
     -- base passes no easing). Subclassing keeps collage-tabs et al untouched. */
  (() => {
    if (customElements.get('featured-products-tabs')) return;
    customElements.whenDefined('tabs-component').then(() => {
      const Base = customElements.get('tabs-component');
      class FeaturedProductsTabs extends Base {
        constructor() {
          super();
          this.focusIndex = this.selectedIndex || 0;
          /* Base defines setActiveTab as an instance arrow field; wrap it so
             activation (click / editor select) re-homes the roving tabindex. */
          const baseSetActiveTab = this.setActiveTab;
          this.setActiveTab = (index) => {
            baseSetActiveTab(Number(index));
            this.syncRovingTabindex(Number(index));
          };
          this.syncRovingTabindex(this.selectedIndex);
        }

        syncRovingTabindex(index) {
          this.focusIndex = index;
          this.domNodes.tabNavs.forEach((tab, i) => {
            tab.setAttribute('tabindex', i === index ? '0' : '-1');
          });
        }

        /* Focus-only traversal per WAI-ARIA manual activation; Enter/Space
           activate via the button's native click -> onTabClick. */
        handleKeyDown(e) {
          const tabs = this.domNodes.tabNavs;
          let next = null;
          if (e.key === 'ArrowRight') next = (this.focusIndex + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') next = (this.focusIndex - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = tabs.length - 1;
          if (next === null) return;
          e.preventDefault();
          tabs[this.focusIndex] && tabs[this.focusIndex].setAttribute('tabindex', '-1');
          this.focusIndex = next;
          tabs[next].setAttribute('tabindex', '0');
          tabs[next].focus();
        }

        async transition(fromPanel, toPanel) {
          await FoxTheme.Motion.animate(
            fromPanel,
            { transform: ['translateY(0)', 'translateY(2rem)'], opacity: [1, 0] },
            { duration: 0.3, easing: 'ease-in-out' }
          ).finished;

          fromPanel.hidden = true;
          toPanel.hidden = false;

          FoxTheme.Motion.animate(
            toPanel,
            { transform: ['translateY(2rem)', 'translateY(0)'], opacity: [0, 1] },
            { duration: 0.3, easing: 'ease-in-out' }
          );
        }

        connectedCallback() {
          super.connectedCallback && super.connectedCallback();
          /* theme-editor.js only knows <tabs-component>; re-implement
             block-select -> tab activation for this element. */
          if (window.Shopify && window.Shopify.designMode && !this.__editorBound) {
            this.__editorBound = true;
            document.addEventListener('shopify:block:select', (evt) => {
              if (!this.contains(evt.target)) return;
              const tab = evt.target.closest('[role="tab"]');
              if (tab && tab.dataset.index) this.setActiveTab(Number(tab.dataset.index));
            });
          }
        }
      }
      customElements.define('featured-products-tabs', FeaturedProductsTabs);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  if (!customElements.get('blog-load-more')) {
    class BlogLoadMore extends HTMLElement {
      connectedCallback() {
        this.loading = false;
        // Negative bottom rootMargin + scroll requirement: a tall footer can
        // place the sentinel in the initial viewport (brief §9.3).
        this.observer = new IntersectionObserver(
          (entries) => entries.forEach((entry) => entry.isIntersecting && this.load()),
          { rootMargin: '0px 0px -80px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer && this.observer.disconnect();
      }

      load() {
        // Inert while hidden (CSS-only mode switch, brief §6.4).
        if (this.loading || getComputedStyle(this).display === 'none') return;
        this.loading = true;

        const url = new URL(this.dataset.url, window.location.origin);

        fetch(url.toString())
          .then((response) => {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then((text) => this.render(text))
          .catch(() => {
            // Failure path (§5.5): reveal the numbered pagination fallback.
            const numbers = document.querySelector('.main-blog__pagination--numbers .pagination-wrapper');
            if (numbers) numbers.style.cssText = 'position:static;overflow:visible;width:auto;height:auto;margin:0;clip:auto;';
            this.remove();
          })
          .finally(() => {
            this.loading = false;
          });
      }

      render(text) {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const grid = document.querySelector('.main-blog__items');
        const incoming = doc.querySelectorAll('.main-blog__items .f-column');
        if (!grid || !incoming.length) return this.remove();

        const existing = new Set(
          Array.from(grid.querySelectorAll('.article-card__title a')).map((a) => a.getAttribute('href'))
        );
        incoming.forEach((column) => {
          const link = column.querySelector('.article-card__title a');
          if (link && existing.has(link.getAttribute('href'))) return;
          grid.appendChild(column);
        });
        // reShowVisibleGridItems animates only style-less (new) columns —
        // showGridItems would re-run the stagger over already-visible cards.
        if (typeof grid.reShowVisibleGridItems === 'function') grid.reShowVisibleGridItems();

        const status = document.querySelector('[data-blog-count-status]');
        const nextStatus = doc.querySelector('[data-blog-count-status]');
        if (status && nextStatus) status.textContent = nextStatus.textContent;

        const nextSentinel = doc.querySelector('blog-load-more');
        if (nextSentinel) {
          this.dataset.url = nextSentinel.dataset.url;
        } else {
          this.remove(); // last page — stop observing
        }
      }
    }
    customElements.define('blog-load-more', BlogLoadMore);
  }

  document.addEventListener('shopify:section:unload', (event) => {
    const sentinel = event.target.querySelector('blog-load-more');
    sentinel && sentinel.observer && sentinel.observer.disconnect();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  (function () {
    function initReadMore(root) {
      var body = root.querySelector('[data-collection-readmore-body]');
      var toggle = root.querySelector('[data-collection-readmore-toggle]');
      if (!body || !toggle) return;

      var more = toggle.querySelector('[data-readmore-more]');
      var less = toggle.querySelector('[data-readmore-less]');

      function measure() {
        body.classList.add('is-clamped');
        var overflowing = body.scrollHeight - body.clientHeight > 1;
        if (overflowing) {
          toggle.hidden = false;
        } else {
          toggle.hidden = true;
          body.classList.remove('is-clamped');
        }
      }

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        body.classList.toggle('is-clamped', expanded);
        if (more) more.hidden = !expanded;
        if (less) less.hidden = expanded;
      });

      measure();
      var rafId = null;
      window.addEventListener('resize', function () {
        if (rafId) return;
        rafId = requestAnimationFrame(function () {
          rafId = null;
          measure();
        });
      });
    }

    document.querySelectorAll('.collection-hero__description').forEach(initReadMore);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class FiltersToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      const collection = this.closest('.collection');
      this.content = collection ? collection.querySelector('.collection__content') : null;
      this.hideLabel = this.querySelector('[data-toggle-hide]');
      this.showLabel = this.querySelector('[data-toggle-show]');
      this.storageKey = 'eureka:plp-filters-collapsed';

      const stored = localStorage.getItem(this.storageKey);
      if (stored === '1') this.setCollapsed(true, false);
      else if (stored === '0') this.setCollapsed(false, false);

      this.button.addEventListener('click', () => {
        const collapsed = !!(this.content && this.content.classList.contains('is-filters-collapsed'));
        this.setCollapsed(!collapsed, true);
      });
    }

    setCollapsed(collapsed, persist) {
      if (this.content) this.content.classList.toggle('is-filters-collapsed', collapsed);
      this.button.setAttribute('aria-pressed', String(!collapsed));
      if (this.hideLabel) this.hideLabel.hidden = collapsed;
      if (this.showLabel) this.showLabel.hidden = !collapsed;
      if (persist) localStorage.setItem(this.storageKey, collapsed ? '1' : '0');
    }
  }

  if (!customElements.get('filters-toggle')) {
    customElements.define('filters-toggle', FiltersToggle);
  }

  // Publishes the sticky filter bar's height as --filter-bar-height so the
  // facet rail can park BELOW it instead of underneath it (QA 2026-08-13).
  //
  // Both are .sticky-element. The bar pins at --sticky-offset: 0, the rail at
  // the 2rem default, so once the page scrolled the rail's top sat ABOVE the
  // bar's bottom edge and the first filter group was cut off behind it. The
  // header was already accounted for -- body.header-pinned adds --header-height
  // -- but nothing accounted for the bar.
  //
  // Measured rather than hard-coded: the row is content-sized (padding + text,
  // and it wraps at narrow widths), so there is no fixed value to reference.
  // Matches how header.js publishes --header-height and sticky-atc-bar.js
  // publishes --sticky-atc-bar-height.
  //
  // Selector requires .sticky-element: when filter_bar_sticky is off the bar
  // scrolls away normally and the rail must NOT reserve space for it, so the
  // variable correctly resolves to 0px.
  (() => {
    const SELECTOR = '.collection__toolbar-row.sticky-element';

    const publish = () => {
      const row = document.querySelector(SELECTOR);
      document.documentElement.style.setProperty(
        '--filter-bar-height',
        row ? Math.round(row.getBoundingClientRect().height) + 'px' : '0px'
      );
    };

    const start = () => {
      publish();
      const row = document.querySelector(SELECTOR);
      if (row && 'ResizeObserver' in window) {
        new ResizeObserver(publish).observe(row);
      } else {
        window.addEventListener('resize', publish);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  // Progressive enhancement only — the login/recover forms are fully
  // functional without JS (server-rendered POST + re-render).
  (function () {
    var root = document.querySelector('.customer.login');
    if (!root) return;

    root.querySelectorAll('form[action*="/account/login"], form[action*="/account/recover"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type="submit"]');
        if (btn) {
          btn.classList.add('btn--loading');
          btn.setAttribute('disabled', '');
        }
        form.setAttribute('aria-busy', 'true');
      });
    });

    root.querySelectorAll('.form-control').forEach(function (input) {
      input.addEventListener('invalid', function () {
        var field = input.closest('.form-field');
        if (field) field.classList.add('form-field--invalid');
      });
      input.addEventListener('input', function () {
        if (input.validity.valid) {
          var field = input.closest('.form-field');
          if (field) field.classList.remove('form-field--invalid');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specs"] && !Shopify.designMode) return;
  try {
    
  class ProductSpecsTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        if (this.panels[i]) this.panels[i].hidden = !selected;
      });
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index === last ? 0 : index + 1;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index === 0 ? last : index - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = last;
      if (next === null) return;
      event.preventDefault();
      this.select(next);
      this.tabs[next].focus();
    }
  }

  if (!customElements.get('product-specs-tabs')) {
    customElements.define('product-specs-tabs', ProductSpecsTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
    /* product-details enhancement for <product-tabs data-product-details>.
       (Selector-gated: no-ops unless a design-3 instance is on the page.)
       The element is registered by theme.js (ProductTabs); it cannot be
       subclassed under the same tag, so instances are patched (precedent:
       featured-products-tabs subclass, brief deviations 10 + section 5B).
       Adds: roving tabindex, Home/End + focus-only arrow traversal (manual
       activation), 300ms ease-in-out panel easing, editor block-select, and
       the opt-in mobile accordion mode. */
    (() => {
      const MOBILE_MQ = window.matchMedia('(max-width: 767.98px)');

      const syncRoving = (host, index) => {
        host.__pdFocusIndex = index;
        host.domNodes.tabNavs.forEach((tab, i) => {
          tab.setAttribute('tabindex', i === index ? '0' : '-1');
        });
      };

      const patchTabs = (host) => {
        syncRoving(host, host.selectedIndex || 0);
        const baseSetActiveTab = host.setActiveTab;
        host.setActiveTab = (index) => {
          baseSetActiveTab(Number(index));
          if (host.dataset.mobileLayout !== 'accordion' || !MOBILE_MQ.matches) {
            syncRoving(host, Number(index));
          }
        };
        /* Own-property transition shadows the prototype; adds the house
           300ms ease-in-out easing (Foundations 7127:60479). */
        host.transition = async (fromPanel, toPanel) => {
          await FoxTheme.Motion.animate(
            fromPanel,
            { transform: ['translateY(0)', 'translateY(2rem)'], opacity: [1, 0] },
            { duration: 0.3, easing: 'ease-in-out' }
          ).finished;
          fromPanel.hidden = true;
          toPanel.hidden = false;
          FoxTheme.Motion.animate(
            toPanel,
            { transform: ['translateY(2rem)', 'translateY(0)'], opacity: [0, 1] },
            { duration: 0.3, easing: 'ease-in-out' }
          );
        };
        /* Capturing keydown beats the base tablist listener (which mutates
           selectedIndex on arrows and desyncs the panel state). */
        const nav = host.querySelector('[role="tablist"]');
        nav &&
          nav.addEventListener(
            'keydown',
            (e) => {
              const tabs = host.domNodes.tabNavs;
              let next = null;
              if (e.key === 'ArrowRight') next = (host.__pdFocusIndex + 1) % tabs.length;
              else if (e.key === 'ArrowLeft') next = (host.__pdFocusIndex - 1 + tabs.length) % tabs.length;
              else if (e.key === 'Home') next = 0;
              else if (e.key === 'End') next = tabs.length - 1;
              if (next === null) return;
              e.preventDefault();
              e.stopImmediatePropagation();
              tabs[host.__pdFocusIndex] && tabs[host.__pdFocusIndex].setAttribute('tabindex', '-1');
              host.__pdFocusIndex = next;
              tabs[next].setAttribute('tabindex', '0');
              tabs[next].focus();
            },
            true
          );
      };
      /* Opt-in accordion (<=767.98px, mobile_layout: accordion — brief §5B).
         Tab roles are REMOVED (not layered) while engaged; teardown restores
         them and re-hides all but data-selected. */
      const setupAccordion = (host) => {
        if (host.dataset.mobileLayout !== 'accordion') return;
        const panels = host.domNodes.tabPanels;
        const tabs = host.domNodes.tabNavs;
        const nav = host.querySelector('[role="tablist"], [data-pd-tablist]');
        const summaries = [];
        panels.forEach((panel, i) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'product-details__summary focus-inset';
          btn.setAttribute('aria-controls', panel.id);
          btn.textContent = tabs[i] ? tabs[i].textContent.trim() : '';
          const chev = document.createElement('span');
          chev.className = 'icon';
          chev.setAttribute('aria-hidden', 'true');
          chev.innerHTML =
            '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 7.5l5 5 5-5" stroke="currentColor" stroke-width="1"/></svg>';
          btn.appendChild(chev);
          panel.parentNode.insertBefore(btn, panel);
          summaries.push(btn);
          btn.addEventListener('click', () => {
            const open = btn.getAttribute('aria-expanded') === 'true';
            summaries.forEach((s, j) => {
              s.setAttribute('aria-expanded', 'false');
              panels[j].hidden = true;
            });
            if (!open) {
              btn.setAttribute('aria-expanded', 'true');
              panel.hidden = false;
            }
          });
          panel.addEventListener('keydown', (e) => {
            if (e.key !== 'Escape' || btn.getAttribute('aria-expanded') !== 'true') return;
            e.stopPropagation();
            btn.setAttribute('aria-expanded', 'false');
            panel.hidden = true;
            btn.focus();
          });
        });
        const engage = () => {
          nav && nav.removeAttribute('role');
          tabs.forEach((t) => {
            t.removeAttribute('role');
            t.removeAttribute('aria-selected');
          });
          panels.forEach((p, i) => {
            p.removeAttribute('role');
            summaries[i].setAttribute('aria-expanded', i === host.selectedIndex ? 'true' : 'false');
            p.hidden = i !== host.selectedIndex;
          });
        };
        const teardown = () => {
          nav && nav.setAttribute('role', 'tablist');
          tabs.forEach((t, i) => {
            t.setAttribute('role', 'tab');
            t.setAttribute('aria-selected', i === host.selectedIndex ? 'true' : 'false');
          });
          panels.forEach((p, i) => {
            p.setAttribute('role', 'tabpanel');
            summaries[i].removeAttribute('aria-expanded');
            p.hidden = i !== host.selectedIndex;
          });
          syncRoving(host, host.selectedIndex);
        };
        MOBILE_MQ.matches ? engage() : teardown();
        MOBILE_MQ.addEventListener('change', (e) => (e.matches ? engage() : teardown()));
      };

      /* compiled_assets/scripts.js runs before theme.js registers the
         element — wait for the upgrade, then patch upgraded instances. */
      customElements.whenDefined('product-tabs').then(() => {
        document.querySelectorAll('product-tabs[data-product-details]').forEach((host) => {
          patchTabs(host);
          setupAccordion(host);
        });
      });

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', (evt) => {
          const host = evt.target.closest('product-tabs[data-product-details]');
          if (!host) return;
          const tab = evt.target.closest('[role="tab"]');
          if (tab && tab.dataset.index) host.setActiveTab(Number(tab.dataset.index));
        });
      }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('related-products-tabs')) {
    customElements.define(
      'related-products-tabs',
      class RelatedProductsTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
          this.tabs.forEach((tab) => tab.addEventListener('click', () => this.activate(tab.dataset.tab)));
        }

        activate(name) {
          this.tabs.forEach((tab) => {
            const active = tab.dataset.tab === name;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          this.querySelectorAll('[data-tab-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.tabPanel !== name;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-copy"] && !Shopify.designMode) return;
  try {
    
  class SeoCopyDisclosure extends HTMLElement {
    connectedCallback() {
      if (this.dataset.disabled === 'true') return;

      this.body = this.querySelector('.seo-copy__body');
      this.toggle = this.querySelector('.seo-copy__toggle');
      if (!this.body || !this.toggle) return;

      this.label = this.toggle.querySelector('.seo-copy__toggle-label');
      this.collapsedHeight = parseInt(this.dataset.collapsedHeight, 10) || 0;

      this.toggle.addEventListener('click', () => {
        if (this.classList.contains('is-collapsed')) {
          this.expand();
        } else {
          this.collapse();
        }
      });

      // Re-run the overflow decision on reflow (the body column halves at
      // 768px); also refreshes a stale expanded inline max-height.
      this.resizeObserver = new ResizeObserver(() => this.refresh());
      this.resizeObserver.observe(this.body);
      this.refresh();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    refresh() {
      const hasToggle = this.classList.contains('seo-copy--has-toggle');
      const overflows = this.body.scrollHeight > this.collapsedHeight + 8;

      if (overflows && !hasToggle) {
        this.classList.add('seo-copy--has-toggle');
        this.collapse();
        this.toggle.hidden = false;
      } else if (!overflows && hasToggle) {
        this.classList.remove('seo-copy--has-toggle', 'is-collapsed');
        this.body.style.maxHeight = '';
        this.toggle.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
      } else if (overflows && !this.classList.contains('is-collapsed')) {
        this.body.style.maxHeight = this.body.scrollHeight + 'px';
      }
    }

    collapse() {
      this.classList.add('is-collapsed');
      this.body.style.maxHeight = '';
      this.toggle.setAttribute('aria-expanded', 'false');
      if (this.label && this.toggle.dataset.labelMore) {
        this.label.textContent = this.toggle.dataset.labelMore;
      }
    }

    expand() {
      this.classList.remove('is-collapsed');
      this.body.style.maxHeight = this.body.scrollHeight + 'px';
      this.toggle.setAttribute('aria-expanded', 'true');
      if (this.label && this.toggle.dataset.labelLess) {
        this.label.textContent = this.toggle.dataset.labelLess;
      }
    }
  }

  if (!customElements.get('seo-copy-disclosure')) {
    customElements.define('seo-copy-disclosure', SeoCopyDisclosure);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.f-site-header__bar');
      this.searchToggle = this.querySelector('[data-site-header-search-toggle]');
      this.searchPanel = this.querySelector('.f-site-header__search');
      this.navToggle = this.querySelector('[data-og-nav-toggle]');

      this.setHeight();
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => this.setHeight());
        this.resizeObserver.observe(this);
      }

      if (this.dataset.transparent === 'true') {
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      if (this.searchToggle && this.searchPanel) {
        this.searchToggle.addEventListener('click', () => this.toggleSearch());
        this.onKeydown = this.onKeydown.bind(this);
        this.addEventListener('keydown', this.onKeydown);
      }

      // `snippets/navigation.liquid` owns the panel's own state but never writes
      // `aria-expanded` back onto an EXTERNAL `[data-og-nav-toggle]` -- it only
      // does so for the panel's internal `[data-og-nav-push]` buttons. It does
      // emit `og-nav:open` / `og-nav:close` (bubbling), so the button's state is
      // mirrored from those rather than from this section's own click handler,
      // which would desync the moment the panel is closed any other way (Escape,
      // backdrop, a link activating).
      if (this.navToggle) {
        this.onNavOpen = () => this.navToggle.setAttribute('aria-expanded', 'true');
        this.onNavClose = () => this.navToggle.setAttribute('aria-expanded', 'false');
        this.addEventListener('og-nav:open', this.onNavOpen);
        this.addEventListener('og-nav:close', this.onNavClose);
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.onKeydown) this.removeEventListener('keydown', this.onKeydown);
      if (this.onNavOpen) {
        this.removeEventListener('og-nav:open', this.onNavOpen);
        this.removeEventListener('og-nav:close', this.onNavClose);
      }
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      if (this.searchPanel.hasAttribute('hidden')) return;
      this.closeSearch();
      this.searchToggle.focus();
    }

    setHeight() {
      requestAnimationFrame(() => {
        const root = document.documentElement;
        root.style.setProperty('--header-height', Math.round(this.offsetHeight) + 'px');
        // `this.offsetTop` is measured against the nearest positioned ancestor,
        // and this host is itself positioned, so it always read 0 -- leaving
        // every `--header-offset-top` consumer in `theme.css` (:1681, :6307,
        // :6467) short by the full announcement-bar height. The contract this
        // section replaces (`assets/header.js:40`) reads the SECTION WRAPPER's
        // offset, which is the distance from the document top, so match it.
        root.style.setProperty('--header-offset-top', Math.round(this.parentElement.offsetTop) + 'px');
      });
    }

    onScroll() {
      if (window.scrollY > 0) {
        this.setAttribute('data-scrolled', '');
      } else {
        this.removeAttribute('data-scrolled');
      }
    }

    toggleSearch() {
      if (this.searchPanel.hasAttribute('hidden')) {
        this.searchPanel.removeAttribute('hidden');
        this.searchToggle.setAttribute('aria-expanded', 'true');
        this.setHeight();
        const field = this.searchPanel.querySelector('input');
        if (field) field.focus();
      } else {
        this.closeSearch();
      }
    }

    closeSearch() {
      this.searchPanel.setAttribute('hidden', '');
      this.searchToggle.setAttribute('aria-expanded', 'false');
      this.setHeight();
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  /* Store finder state channel: publishes store-finder:store-selected /
     -deselected on the section root and mirrors the selection as
     [data-selected-store] + [data-store-finder-state] (brief section 5.2 /
     6.1). Row animation + single-open come from the theme AccordionGroup
     primitive; this only observes native `toggle`. Also resolves the
     ?store=<block-id> deep link client-side (Liquid cannot read the query
     string, so the brief's server-rendered variant is not possible). */
  (function () {
    if (window.__storeFinderInit) return;
    window.__storeFinderInit = true;

    var update = function (details) {
      var root = details.closest('.store-finder');
      if (!root) return;
      var id = details.getAttribute('data-store-id');
      if (details.open) {
        root.setAttribute('data-selected-store', id);
        root.setAttribute('data-store-finder-state', 'selected');
        root.dispatchEvent(
          new CustomEvent('store-finder:store-selected', {
            bubbles: true,
            detail: { storeId: id, source: 'list' },
          })
        );
      } else if (root.getAttribute('data-selected-store') === id) {
        root.removeAttribute('data-selected-store');
        root.setAttribute('data-store-finder-state', 'default');
        root.dispatchEvent(
          new CustomEvent('store-finder:store-deselected', {
            bubbles: true,
            detail: { storeId: id },
          })
        );
      }
    };

    document.addEventListener(
      'toggle',
      function (event) {
        var el = event.target;
        if (el && el.classList && el.classList.contains('store-finder__row')) {
          update(el);
        }
      },
      true
    );

    var openFromQuery = function () {
      var store;
      try {
        store = new URLSearchParams(window.location.search).get('store');
      } catch (error) {
        return;
      }
      if (!store) return;
      var row = document.querySelector('.store-finder__row[data-store-id="' + CSS.escape(store) + '"]');
      if (row && !row.open) {
        row.open = true;
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openFromQuery);
    } else {
      openFromQuery();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('f-usp-marquee')) {
    class FUspMarquee extends HTMLElement {
      connectedCallback() {
        if (this.dataset.fUspReady === 'true') return;

        const root = this.closest('.f-usp-strip');
        if (!root || !root.classList.contains('f-usp-strip--marquee')) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (document.body && document.body.classList.contains('disable-animations')) return;

        const track = this.querySelector('.f-usp-strip__track');
        if (!track) return;

        this.root = root;
        this.track = track;
        this.dataset.fUspReady = 'true';

        // Track width is font dependent, so measuring before the web fonts
        // settle produces a seam gap that no later frame corrects.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.build());
        } else {
          this.build();
        }
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }

      build() {
        if (!this.isConnected) return;

        // The class has to land first: until it does the track is the static
        // grid and measures the container width, not its own content width.
        this.root.classList.add('f-usp-strip--is-animating');

        const trackWidth = this.track.getBoundingClientRect().width;
        const viewportWidth = this.getBoundingClientRect().width;

        if (trackWidth <= 0) {
          this.root.classList.remove('f-usp-strip--is-animating');
          return;
        }

        const copies = Math.max(1, Math.ceil((viewportWidth * 2) / trackWidth));
        for (let i = 0; i < copies; i++) {
          this.appendChild(this.cloneTrack());
        }

        this.watch();
      }

      cloneTrack() {
        const clone = this.track.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');

        // Every theme block arrives inside a Shopify wrapper carrying a unique
        // id and a data-shopify-editor-block handle. Cloning those verbatim is
        // what makes the inherited scrolling-promotion element unusable here:
        // it ships duplicate ids page wide and points the theme editor's block
        // picker at the wrong node.
        const stale = clone.querySelectorAll('[id], [data-shopify-editor-block]');
        for (let i = 0; i < stale.length; i++) {
          stale[i].removeAttribute('id');
          stale[i].removeAttribute('data-shopify-editor-block');
        }

        return clone;
      }

      watch() {
        if (!('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.root.classList.toggle('f-usp-strip--paused', !entry.isIntersecting);
          });
        });

        this.observer.observe(this);
      }
    }

    customElements.define('f-usp-marquee', FUspMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
